import DceJsxRenderer from "./DceJsxRenderer";
import getAttrEventType from "./getAttrEventType";

const entityMap: { [key: string]: any } = {
    '&': 'amp',
    '<': 'lt',
    '>': 'gt',
    '"': 'quot',
    "'": '#39',
    '/': '#x2F'
};

const attributesMap: { [key: string]: any } = {
    tabIndex: 'tabindex',
    className: 'class',
    readOnly: 'readonly'
};

export default class DceJsx {

    public static contextObj: DceJsxRenderer[] = [];

    public static pushContextObj(ct: DceJsxRenderer) {
        DceJsx.contextObj.push(ct);
    }

    public static popContextObj() {
        DceJsx.contextObj.pop();
    }

    public static escapeHtml(str: any): any {
        if (typeof str === 'string' || str instanceof String) {
            return str.replace(/[&<>"'\\]/g, s => `&${entityMap[s]};`);
        }
        return str;
    }

    public static mapAttribute(val: string): string {
        return attributesMap[val] || val;
    }

    public static attachEvent(elem: HTMLElement, attr: string, val: any): boolean {
        if (!attr.startsWith("on") || typeof val !== 'function') {
            return false
        }

        let eventType = getAttrEventType(attr);
        if (null != eventType) {
            elem.addEventListener(eventType, val);
            return true;
        }

        return false;
    }

    public static createElement(tag: Function | string, attrs?: { [key: string]: any }, ...children: (HTMLElement | string)[]): HTMLElement {
        attrs = attrs || {};
        const stack: any[] = [...children];

        // Support for components(ish)
        if (typeof tag === 'function') {
            attrs.children = stack;
            return tag(attrs);
        }

        const elm = document.createElement(tag);

        let ref: string = null;

        // Add attributes
        for (let [name, val] of Object.entries(attrs)) {

            if (name === 'ref' && DceJsx.contextObj.length > 0 && typeof val === 'string') {
                ref = val;
            }

            name = DceJsx.escapeHtml(DceJsx.mapAttribute(name));

            if (DceJsx.attachEvent(elm, name, val)) {
                //intentionally blank!
            } else if (name == 'dangerouslySetInnerHTML') {
                elm.innerHTML = val.__html;
            } else if (name === 'style') {
                Object.assign(elm.style, val);
            } else if (val === true) {
                elm.setAttribute(name, name);
            } else if (val !== false && val != null) {
                elm.setAttribute(name, DceJsx.escapeHtml(val));
            } else if (val === false) {
                elm.removeAttribute(name);
            }
        }

        // Append children
        while (stack.length) {
            const child = stack.shift();

            // Is child a leaf?
            if (!Array.isArray(child)) {
                if (child != undefined) {
                    elm.appendChild(
                        (child as HTMLElement).nodeType == null
                            ? document.createTextNode(child.toString())
                            : child
                    );
                }
            } else {
                stack.push(...child);
            }
        }

        if (null != ref) {
            DceJsx.contextObj[DceJsx.contextObj.length - 1].bindByRefMetadata(ref, elm);
            DceJsx.contextObj[DceJsx.contextObj.length - 1].bindByRef(ref, elm);
        }

        return elm;
    }
}
